module.exports = __webpack_public_path__ + "static/media/tower2.eaa06ad9.png";